// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__V-_T8","footer":"ModalCreateQualiphyProcedure_footer__2uv44","additionData":"ModalCreateQualiphyProcedure_additionData__3rsA0"};